/**
 * Belső relatív útvonal ellenőrzése (open redirect ellen).
 * @param {string|null|undefined} raw – URL-encoded vagy sima string
 * @returns {string|null}
 */
export function getSafeReturnUrl(raw) {
  if (raw == null || raw === '') return null;
  const s = typeof raw === 'string' ? raw : String(raw);
  let u;
  try {
    u = decodeURIComponent(s);
  } catch {
    return null;
  }
  if (!u.startsWith('/') || u.startsWith('//')) return null;
  if (u.includes('://') || u.includes('\\')) return null;
  return u;
}

export function loginUrlWithReturn(pathWithSearch) {
  const path = pathWithSearch || '/';
  return `/admin/login?returnUrl=${encodeURIComponent(path)}`;
}

export const SAFETY_FORUM_PATH = '/safety-forum';
